import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";

const RejectUser = (uid) => {
  let DocRef = doc(db, "Users", uid);

  try {
    setDoc(
      DocRef,
      {
        IsVerified: 2,
      },
      { merge: true }
    );
    return true;
  } catch (error) {
    return false;
  }
};

export default RejectUser;
